import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { languages } from './lang/index.js'

const messages = Object.assign(languages)

Vue.use(VueI18n);

/* const messages = {
    'it': {
        it_lang:"Italiano",
        cz_lang:"Ceco",
        home_popover:" ci amiamo tanto, scopri di più su di noi",
        info:"info",
        rsvp:"rsvp",
        whereWhen:"Dove & Quando",
        how:"Come arrivare",
        sleep:"  Dove dormire",
        gift:"Cosa regalarci",
        extra:"extra",
        visit:"Cosa visitare",
        forecast:"Previsioni Meteo",
        contact:"Contattaci",
        welcome:"BENVENUTI",
        welcome_message:"Over the span of the satellite record, Arctic sea ice has"+
                    "been declining significantly, while sea ice in the"+
                    "Antarctichas increased very slightly",
        Days:"Giorni",
        Hours:"Ore",
        Minutes:"Minuti",
        Seconds:"Secondi"
    },
    'cz': {
        it_lang:"italsky",
        cz_lang:"česky",
        home_popover:"Máme se rádi, chceš se o nás dozvědět víc?",
        info:"info",
        rsvp:"rsvp",
        whereWhen:"Kde & Kdy",
        how:"Jak dorazit",
        sleep:"Kde přespat",
        gift:"Co nám darovat",
        extra:"extra",
        visit:"Co navštívit",
        forecast:"Jak bude?",
        contact:"Pošli nám zprávu",
        welcome:"VÍTAME VÁS",
        welcome_message:"Vítáme Vás na našich svatebních stránkáchs"+
                    "been declining significantly, while sea ice in the"+
                    "Antarctichas increased very slightly",
        Days:"Giorni",
        Hours:"Ore",
        Minutes:"Minuti",
        Seconds:"Secondi"
    }
}; */

const i18n = new VueI18n({
    locale: navigator.language.substring(0, 2) || navigator.userLanguage.substring(0, 2), // set locale
    fallbackLocale: 'cz', // set fallback locale
    messages, // set locale messages
});

export default i18n;